CoWorkRouting.$inject = ["$urlRouterProvider", "$stateProvider"];

function CoWorkRouting($urlRouterProvider, $stateProvider) {

 $urlRouterProvider.otherwise("/CoWork/CoWorkList");

  $stateProvider

  .state('CoWork',{

   abstract: true,

  url: '/CoWork',

  template: '<ui-view id="CoWork"></ui-view>'

    })

  .state('CoWork.CoWorkList',{

  url: '/CoWorkList',

  controller: 'CoWork.CoWorkListController',

  controllerAs: 'self',

  templateProvider: ['$q', ($q) => {

      return $q((resolve) => {

          require.ensure([], () => {

              let template = require('./CoWorkList/views/index.html');

              resolve(template);

          });

      });

  }],

  resolve: {

      Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

        let deferred = $q.defer();

        require.ensure([], function () {

            let module = require('./CoWorkList/CoworkList.module');

            $ocLazyLoad.load({

                name: 'CoWorkListModule',

            });

            deferred.resolve(module);

        });

        return deferred.promise;

      }]

  },
  breadcrumbData: {
      title: "لیست فضاهای اشتراکی",
      icon: "fas fa-tasks"
  }


	})
  .state('CoWork.JoinCoWork',{

  url: '/JoinCoWork/:id',

  controller: 'CoWork.JoinCoWorkController',

  controllerAs: 'self',

  templateProvider: ['$q', ($q) => {

      return $q((resolve) => {

          require.ensure([], () => {

              let template = require('./JoinCoWork/views/index.html');

              resolve(template);

          });

      });

  }],

  resolve: {

      Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

        let deferred = $q.defer();

        require.ensure([], function () {

            let module = require('./JoinCoWork/JoinCoWork.module');

            $ocLazyLoad.load({

                name: 'JoinCoWorkModule',

            });

            deferred.resolve(module);

        });

        return deferred.promise;

      }]

  },
  breadcrumbData: {
      parent: "CoWork.CoWorkList",
      title: "ثبت نام در فضای اشتراکی",
      icon: "fas fa-plus"
  }

	})
  .state('CoWork.JoinRequestReceive',{

  url: '/JoinRequestReceive',

  controller: 'CoWork.JoinRequestReceiveController',

  controllerAs: 'self',

  templateProvider: ['$q', ($q) => {

      return $q((resolve) => {

          require.ensure([], () => {

              let template = require('./JoinRequestReceive/views/index.html');

              resolve(template);

          });

      });

  }],

  resolve: {

      Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

        let deferred = $q.defer();

        require.ensure([], function () {

            let module = require('./JoinRequestReceive/JoinRequestReceive.module');

            $ocLazyLoad.load({

                name: 'JoinRequestReceiveModule',

            });

            deferred.resolve(module);

        });

        return deferred.promise;

      }]

  },
  breadcrumbData: {
      title: "در خواست های عضویت",
      icon: "fas fa-stopwatch"
  }

	})
  .state('CoWork.JoinRequestReceiveDetail',{

  url: '/JoinRequestReceiveDetail/:Id',

  controller: 'CoWork.JoinRequestReceiveDetailController',

  controllerAs: 'self',

  templateProvider: ['$q', ($q) => {

      return $q((resolve) => {

          require.ensure([], () => {

              let template = require('./JoinRequestReceiveDetail/views/index.html');

              resolve(template);

          });

      });

  }],

  resolve: {

      Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

        let deferred = $q.defer();

        require.ensure([], function () {

            let module = require('./JoinRequestReceiveDetail/JoinRequestReceiveDetail.module');

            $ocLazyLoad.load({

                name: 'JoinRequestReceiveDetailModule',

            });

            deferred.resolve(module);

        });

        return deferred.promise;

      }]

  }
  ,
  breadcrumbData: {
      parent: "CoWork.JoinRequestReceive",
      title: "بررسی یک درخواست ",
      icon: "fas fa-cogs"
  }
	})
  .state('CoWork.JoinRequestSend',{

  url: '/JoinRequestSend',

  controller: 'CoWork.JoinRequestSendController',

  controllerAs: 'self',

  templateProvider: ['$q', ($q) => {

      return $q((resolve) => {

          require.ensure([], () => {

              let template = require('./JoinRequestSend/views/index.html');

              resolve(template);

          });

      });

  }],

  resolve: {

      Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

        let deferred = $q.defer();

        require.ensure([], function () {

            let module = require('./JoinRequestSend/JoinRequestSend.module');

            $ocLazyLoad.load({

                name: 'JoinRequestSendModule',

            });

            deferred.resolve(module);

        });

        return deferred.promise;

      }]

  }
  ,
  breadcrumbData: {
      parent: "CoWork.CoWorkList",
      title: "لیست درخواست های عضویت من",
      icon: "fas fa-tasks"
  }
    }).state('CoWork.MembersList', {

        url: '/MembersList',

        controller: 'CoWork.MembersListController',

        controllerAs: 'self',

        controllerAs: 'self',

        templateProvider: ['$q', ($q) => {

            return $q((resolve) => {

                require.ensure([], () => {

                    let template = require('./MembersList/views/index.html');

                    resolve(template);

                });

            });

        }],

        resolve: {

            Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                let deferred = $q.defer();

                require.ensure([], function () {

                    let module = require('./MembersList/MembersList.module');

                    $ocLazyLoad.load({

                        name: 'MembersListModule',

                    });

                    deferred.resolve(module);

                });

                return deferred.promise;

            }]

        },
        breadcrumbData: {
            parent: "CoWork.CoWorkList",
            title: "لیست اعضا",
            icon: "fas fa-list"
        }

    }).state('CoWork.MembershipList', {

        url: '/MembershipList',

        controller: 'CoWork.MembershipListController',

        controllerAs: 'self',

        controllerAs: 'self',

        templateProvider: ['$q', ($q) => {

            return $q((resolve) => {

                require.ensure([], () => {

                    let template = require('./MembershipList/views/index.html');

                    resolve(template);

                });

            });

        }],

        resolve: {

            Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                let deferred = $q.defer();

                require.ensure([], function () {

                    let module = require('./MembershipList/MembershipList.module');

                    $ocLazyLoad.load({

                        name: 'MembershipListModule',

                    });

                    deferred.resolve(module);

                });

                return deferred.promise;

            }]

        },
        breadcrumbData: {
            parent: "CoWork.CoWorkList",
            title: "عضویت های من",
            icon: "fas fa-list"
        }

    }) /*endOfResolve*/ ;

}



export default CoWorkRouting;
